import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/lib/services/common.service';

@Component({
  selector: 'app-delivery-day-preference',
  templateUrl: './delivery-day-preference.component.html',
  styleUrls: ['./delivery-day-preference.component.scss'],
  providers: [DatePipe],
  standalone: false
})

export class DeliveryDayPreferenceComponent implements OnInit {
  @Input() scheduleTime = false;
  @Input() hideNow: boolean = false;
  @Input() product: any;
  openCalendar: any;
  todayDate: String = new Date().toISOString();
  selectedDate: any;
  dateSelected: any;
  dayAfterTomorrowDate: any;
  twoDaysAfterTomorrowDate: any;
  threeDaysAfterTomorrowDate: any;

  data = [
    new Date(new Date().getTime() + 19800000).toJSON().split('T')[0],
    new Date(new Date().getTime() + 19800000 + 86400000).toJSON().split('T')[0],
    new Date(new Date().getTime() + 19800000 + (86400000 * 2)).toJSON().split('T')[0],
    new Date(new Date().getTime() + 19800000 + (86400000 * 3)).toJSON().split('T')[0],
  ];

  constructor(
    private datePipe: DatePipe,
    private modalCtrl: ModalController,
    public commonService: CommonService,
  ) {
    this.openCalendar = 1;
  }

  ngOnInit() {
    // Calculate the dynamic dates
    this.dayAfterTomorrowDate = moment().add(2, 'days').format('DD');
    this.twoDaysAfterTomorrowDate = moment().add(3, 'days').format('DD');
    this.threeDaysAfterTomorrowDate = moment().add(4, 'days').format('DD');
  }

  async cancel() {
    await this.modalCtrl.dismiss();
  }

  hide() {
    this.openCalendar = 0;
  }

  getDate(value: any) {
    if (value) {
      if (new Date(new Date(value).getTime() + 19800000).toJSON().split('T')[0] == new Date(new Date().getTime() + 19800000).toJSON().split('T')[0]) {
        return this.commonService.getTranslatedMessage('Today') || 'Today';
      } else if (new Date(new Date(value).getTime() + 19800000).toJSON().split('T')[0] == new Date(new Date().getTime() + 19800000 + 86400000).toJSON().split('T')[0]) {
        return this.commonService.getTranslatedMessage('Tomorrow') || 'Tomorrow';
      } else {
        return this.datePipe.transform(value, 'dd MMM');
      }
    } else {
      return value;
    }
  }

  setDeliveryDate(date: any): void {
    this.setDeliverySlot(date);
  }

  setDeliverySlot(date): void {
    this.modalCtrl.dismiss({
      date: date
    });
  }

  setDeliverySlotNow() {
    const todayDate = new Date(new Date().getTime() + 19800000).toJSON().split('T')[0];
    this.modalCtrl.dismiss({ date: todayDate, orderType: 'NOW' });
  }
}
